<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import { required } from "vuelidate/lib/validators";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Vue from "vue";
import axios from "axios";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
// import MaskedInput from "vue-text-mask";
Vue.component("v-select", vSelect);
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
// register the plugin on vue
import Toasted from "vue-toasted";

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.
/**
 * Departamento component
 */
export default {
  page: {
    title: "Días de vencimiento",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    Vuetable,
    VuetablePagination,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
  },
  data() {
    return {
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      repit: true,
      apiUrl: process.env.VUE_APP_URL,
      apiBase: process.env.VUE_APP_URL + "configuraciones/get",
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      formPro: {
        diasDisponibles: "",
        state: true,
        id: 0,
      },
      updating: false,
      estadotabla: true,
      title: "Días de vencimiento",
      itemst: [
        {
          text: "Ventas",
          href: "/",
        },
        {
          text: "Días de vencimiento",
          active: true,
        },
      ],
      fields: [
        {
          name: "dias_disponibles",
          title: "Días disponibles",
          //   sortField: "persona.nombre_persona",
          // width: "20%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          // width: "10%",
        },
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          // width: "10%",
        },
      ],
      searchType: [{ nombre: "Nombre", value: "nombre" }],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      loadingtable: false,
      sortBy: "nombre_servicio",
      sortDesc: false,
      searchLabel: { nombre: "Nombre", value: "nombre" },
      filterLabel: { nombre: "Nombre", value: "nombre" },
      showModalL: false, //Loading
      showModalE: false, //Editar
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      data: [],
      pageOptions: [4, 10, 15, 20],
      search: "",
      page: 1,
      perPage: 4,
      from: 0,
      to: 0,
      total: 0,
      lastPage: 0,
    };
  },
  validations: {
    formPro: {
      diasDisponibles: {
        required,
      },
    },
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    //Validaciones antes de guardar
    validaciones(opc) {
      // stop here if form is invalid
      this.$v.$touch();
      const { nombre, descripcion } = this.formPro;
      // console.log(this.formPro);
      /*  if (this.$v.$invalid ) { */
      if (nombre != "" && descripcion != "") {
        this.showModalL = true;
        if (opc == "save") {
          this.save();
        }
        if (opc == "update") {
          this.update();
        }
      } else {
        Vue.toasted.error("Complete los campos del servicio", this.options);
      }
    },
    //Desactivar registro
    desactivate() {
      const { id, nombre } = this.formPro;
      axios
        .put(
          process.env.VUE_APP_URL + "servicios/desactivate",
          {
            id: id,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          this.showModalD = false;
          Vue.toasted.error(nombre + " desactivado", this.options);
          this.$refs.vuetable.refresh();
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para desactivar", this.options);
        });
    },
    //Activar registro
    activate() {
      const { id, nombre } = this.formPro;
      axios
        .put(
          process.env.VUE_APP_URL + "servicios/activate",
          {
            id: id,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          this.showModalA = false;
          Vue.toasted.info(nombre + " activado", this.options);
          this.$refs.vuetable.refresh();
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para activar", this.options);
        });
    },
    //Guardar registro
    // save() {
    //   const { nombre, descripcion } = this.formPro;
    //   const me = this;
    //   axios
    //     .post(process.env.VUE_APP_URL + "servicios/store", {
    //       nombre,
    //       descripcion,
    //     })
    //     .then(() => {
    //       Vue.toasted.success(nombre + " Guardado", this.options);
    //       me.$refs.vuetable.refresh();
    //       this.showModalN = false;
    //     })
    //     .catch((error) => {
    //       this.errorMessage = error.message;
    //       console.error("Error!", error);
    //       Vue.toasted.error("Error para guardar", this.options);
    //     })
    //     .finally(() => {
    //       this.showModalL = false;
    //     });
    // },
    //ACtualizar registro
    update() {
      const { diasDisponibles, id } = this.formPro;
      const me = this;
      axios
        .put(
          process.env.VUE_APP_URL + "configuraciones/update",
          {
            id: id,
            dias_disponibles: diasDisponibles,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          Vue.toasted.success("Días actualizados", this.options);
          me.$refs.vuetable.refresh();
          this.showModalE = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
        });
    },
    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
      this.$refs.pagination.setPaginationData(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },

    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "nombre_persona",
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          }
        : {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "nombre_persona",
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          };
    },
    //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
    openModal(model) {
      switch (model) {
        case "save": {
          this.$v.$reset();
          this.limpiarVariables();

          // console.log("entrando a resetear")
          break;
        }
        case "update": {
          this.$v.$reset();
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
    limpiarVariables() {
      this.formPro.id = 0;
      this.formPro.diasDisponibles = "";
    },
    //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
    closeModal(model) {
      switch (model) {
        case "save": {
          this.showModalN = false;
          this.showmodalL = false;
          break;
        }
        case "update": {
          this.showModalE = false;
          this.showmodalL = false;
          break;
        }
      }
    },

    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    onActionClicked(action, data) {
      if (action == "edit-item") {
        this.formPro.diasDisponibles = data.dias_disponibles;
        this.formPro.id = data.id;
      }
      //   if (action == "new-item") {
      //     this.formPro.nombre = "";
      //     this.formPro.descripcion = "";
      //   }
      //   if (action == "desactivate-item") {
      //     this.formPro.nombre = data.nombre_servicio;
      //     this.formPro.id = data.id;
      //     this.showModalD = true;
      //   }
      //   if (action == "activate-item") {
      //     this.formPro.nombre = data.nombre_servicio;
      //     this.formPro.id = data.id;
      //     this.showModalA = true;
      //   }
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style>
/* Css para el loading en el modal */
.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>

<template>
  <Layout>
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">
        <b-modal
          centered
          v-model="showModalL"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
          no-close-on-backdrop
          content-class="my-class"
          header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->

            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                    :animation-duration="2000"
                    :size="90"
                    color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Activar -->
        <!-- <b-modal
          centered
          v-model="showModalA"
          title="Activar Departamento"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>¿Desea activar el servicio {{ this.formPro.nombre }}?</h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalA = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="activate">Activar</b-button>
            </div>
          </form>
        </b-modal> -->

        <!-- Modal para Desactivar -->
        <!-- <b-modal
          centered
          v-model="showModalD"
          title="Desactivar"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>
                    ¿Desea desactivar al servicio {{ this.formPro.nombre }}?
                  </h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalD = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="desactivate"
                >Desactivar</b-button
              >
            </div>
          </form>
        </b-modal> -->

        <!-- Modal para Editar-->
        <b-modal
          centered
          ref="modalUpdate"
          id="modalUpdate"
          title="Editar días disponibles"
          no-close-on-backdrop
          v-model="showModalE"
          @hidden="closeModal('update')"
          @show="openModal('uptade')"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <!-- Descripcion -->
            <div class="col-12">
              <div class="mb-3">
                <label for="phone">Días disponibles</label>
                <input
                  id="phone"
                  v-model.trim="$v.formPro.diasDisponibles.$model"
                  :state="!$v.formPro.diasDisponibles.$error"
                  :class="{
                    'is-invalid': $v.formPro.diasDisponibles.$error,
                  }"
                  type="number"
                  class="form-control"
                  placeholder="Ingrese los días disponiblees"
                />
                <div
                  :class="{
                    'invalid-feedback': true,
                    'd-block':
                      $v.formPro.diasDisponibles.$error &&
                      !$v.formPro.diasDisponibles.required,
                  }"
                >
                  Los días son requeridos
                </div>
              </div>
            </div>
            <!-- Botones -->
            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalE = false"
                >Cerrar</b-button
              >
              <b-button
                @click="validaciones('update')"
                variant="success"
                class="ms-1"
                >Actualizar</b-button
              >
            </div>
          </form>
        </b-modal>

        <!-- Modal de Nuevo Registro-->
        <!-- <b-modal
          centered
          @show="openModal('save')"
          @hidden="openModal('save')"
          v-model="showModalN"
          id="modalCliente"
          ref="modalCliente"
          title="Nuevo servicio"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="col-12">
              <div class="mb-3">
                <label for="name">Nombre del servicio</label>
                <input
                  id="name"
                  v-model="$v.formPro.nombre.$model"
                  type="text"
                  class="form-control"
                  placeholder="Ingrese un nombre"
                  :class="{
                    'is-invalid': $v.formPro.nombre.$error,
                  }"
                  @input="$v.formPro.nombre.$touch()"
                />
                <div
                  v-if="$v.formPro.nombre.$error && !$v.formPro.nombre.required"
                  class="invalid-feedback"
                >
                  El nombre es obligatorio.
                </div>
                <div
                  v-if="!$v.formPro.nombre.isUnique"
                  :class="{
                    'invalid-feedback': !$v.formPro.nombre.isUnique,
                  }"
                >
                  El nombre del servicio {{ formPro.nombre }} ya existe en
                  nuestros registros.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="phone">Descripción del servicio</label>
                <input
                  id="phone"
                  v-model.trim="$v.formPro.descripcion.$model"
                  :state="!$v.formPro.descripcion.$error"
                  :class="{
                    'is-invalid': $v.formPro.descripcion.$error,
                  }"
                  type="text"
                  class="form-control"
                  placeholder="Ingrese descripción"
                />
                <div
                  :class="{
                    'invalid-feedback': true,
                    'd-block':
                      $v.formPro.descripcion.$error &&
                      !$v.formPro.descripcion.required,
                  }"
                >
                  Descripció requerida
                </div>
              </div>
            </div>
            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalN = false"
                >Cerrar</b-button
              >
              <b-button
                @click="validaciones('save')"
                variant="success"
                class="ms-1"
                >Guardar</b-button
              >
            </div>
          </form>
        </b-modal> -->

        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Configurar días de vencimiento</h4>
            <div class="row mt-4">
              <!-- <div class="col-sm-12 col-md-2">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      @input="changePageSize()"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                  </label>
                </div>
              </div> -->

              <!-- <div class="col-sm-12 col-md-2">
                <div
                  id="tickets-table_length"
                  class="dataTables_length text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <b-dropdown v-if="searchType" id="ddown1" size="sm">
                      <template v-slot:button-content>
                        {{ "Ordenar por: " + searchLabel.nombre }}
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item
                        v-for="(search, index) in searchType"
                        :key="index"
                        @click="changeTypeSearch(search)"
                        >{{ search.nombre }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </label>
                </div>
              </div> -->

              <!-- <div class="col-sm-12 col-md-3 text-md-start">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                      v-model="search"
                      type="search"
                      @input="onFiltered()"
                      placeholder="Buscar..."
                      class="form-control form-control-sm"
                    ></b-form-input>
                  </label>
                </div>
              </div> -->

              <!-- <div class="col-sm-12 col-md-5">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-right">
                    <button
                      v-b-modal.modalCliente
                      type="button"
                      class="btn btn-success btn-rounded mb-2 me-2"
                      @click="onActionClicked('new-item')"
                    >
                      <b>AGREGAR NUEVO</b>&nbsp;&nbsp;<i
                        class="bx bxs-plus-circle"
                      ></i>
                    </button>
                  </label>
                </div>
              </div> -->

              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <vuetable
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :http-options="httpOptions"
                :api-url="apiBase"
                :reactive-api-url="true"
                :fields="fields"
                :per-page="perPage"
                :query-params="makeQueryParams"
                pagination-path
                @vuetable:pagination-data="onPaginationData"
              >
                <div slot="actions" slot-scope="props">
                  <b-button-group class="mt-4 mt-md-0">
                    <b-button
                      v-if="props.rowData.estado_configuracion"
                      tabindex="0"
                      v-b-tooltip.focus
                      title="Editar"
                      variant="outline-primary"
                      v-b-modal.modalUpdate
                      @click="onActionClicked('edit-item', props.rowData)"
                      ><i class="bx bx-edit-alt"></i>
                    </b-button>

                    <!-- <b-button
                      tabindex="0"
                      v-b-tooltip.focus
                      title="Cambiar Estado"
                      :variant="
                        props.rowData.estado_servicio == true
                          ? 'outline-danger'
                          : 'outline-success'
                      "
                      @click="
                        props.rowData.estado_servicio == true
                          ? onActionClicked('desactivate-item', props.rowData)
                          : onActionClicked('activate-item', props.rowData)
                      "
                    >
                      <i
                        :class="
                          props.rowData.estado_servicio == true
                            ? 'bx bx-trash-alt'
                            : 'bx bx-list-check'
                        "
                      ></i>
                    </b-button> -->
                  </b-button-group>
                </div>

                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado_configuracion == true">
                    <span class="badge bg-success ms-1"
                      ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                      ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>
              </vuetable>
              <div style="padding-top: 10px">
                <vuetable-pagination
                  ref="pagination"
                  :css="css.pagination"
                  @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
